// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__38wrQ","savePackageButton":"ClientWallet_savePackageButton__22c4F"};